




















import { Vue, Component } from 'vue-property-decorator'
import BaseEnroll from '@/views/Enroll/components/common/BaseEnroll.vue'
import ReselectMajorForm from './components/ReselectMajorForm.vue'
import { ConfigStore } from '@/store/config'
import { ReselectMajor as ReselectMajorModel } from '@/models/Reselect/ReselectMajor'
import {
  fetchReselectMajor,
  updateReselectMajor,
  createReselectMajor
} from '@/apis/enroll/reselectMajor'
import { fetchStudentInfo } from '@/apis/enroll/studentInfo'
import { Guid } from '@/utils/random'

@Component({
  components: { BaseEnroll, ReselectMajorForm }
})
export default class ReselectMajor extends Vue {
  model: ReselectMajorModel = {
    studentId: '',
    depName: '',
    commitYear: '',
    commitMonth: '',
    commitDay: '',
    studentName: '',
    regiestNumber: '',
    studentOrigin: '',
    studentNumber: '',
    oldMajor: '',
    applyMajor: '',
    chineseScore: '',
    mathScore: '',
    englishScore: '',
    chineseRank: '',
    mathRank: '',
    englishRank: '',
    applyReason: '',
    jWCOpinion: '',
    leaderOpinion: '',
    idCard: '',
    phoneNumber: '',
    id: Guid.NewGuid()
  }

  ajaxFetch = fetchReselectMajor
  ajaxCreate = createReselectMajor
  ajaxUpdate = updateReselectMajor

  get config() {
    return (
      ConfigStore.configs.find(a => a.key === 'reselect-major')?.value ?? {}
    )
  }

  async handleCreated(state: string) {
    switch (state) {
      case 'create': {
        const info = await fetchStudentInfo()

        const date = new Date()
        const today = {
          year: date.getFullYear().toString(),
          month: (date.getMonth() + 1).toString(),
          day: date.getDate().toString()
        }

        const reselectmajor = {
          studentId: '',
          depName: info.collegeName,
          commitYear: today.year,
          commitMonth: today.month,
          commitDay: today.day,
          studentName: info.name,
          regiestNumber: info.gkbmh,
          studentOrigin: info.studentOrigin,
          studentNumber: info.studnetNum,
          oldMajor: info.enrollMajor,
          applyMajor: '',
          chineseScore: info.chineseScore,
          mathScore: info.mathScore,
          englishScore: info.englishScore,
          chineseRank: '',
          mathRank: '',
          englishRank: '',
          applyReason: '',
          jWCOpinion: '',
          leaderOpinion: '',
          idCard: info.idCard,
          phoneNumber: '',
          id: Guid.NewGuid()
        }

        this.model = reselectmajor
        break
      }

      default:
        break
    }
  }
}
